import React from "react";
import { ControlLabel, Button, Alert, FormControl, Radio } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import DatePicker from "react-bootstrap-date-picker";

export default class AddAnnouncement extends React.Component {
    constructor(props) {
        super(props);
        var dateToday = new Date().toISOString();
        
        this.state = {
            announcementIdValue: '',
            title: '',
            linkTypeLabel: '',
            linkIdLabel: '',
            groupByLabel: '',
            startDateLabel: '',
            endDateLabel: '',
            headerLabel: '',
            descriptionLabel: '',
            stickyLabel: '',
            showNewIconLabel: '',
            sendEmailLabel: '',
            fileNameLabel: '',
            navigateUrlLabel: '',
            saveLabel: '',
            backLabel: '',
            addNewLabel: '',
            deleteLabel: '',
            showDetailLabel: '',
            confirmDeleteLabel: '',
            linkTypes: [],
            yesNoList: [],
            errors: [],
            linkTypeValue: '',
            linkIdValue: '',
            groupByValue: '',
            startDate: dateToday,
            startDateValue: '',
            endDate: '',
            endDateValue: '',
            headerValue: '',
            descriptionValue: '',
            stickyValue: '',
            showNewIconValue: '',
            sendEmailValue: '',
            fileNameValue: 'http://',
            navigateUrlValue: 'http://',
            deleteDisabled: true,
            alertStyle: ''
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onAddNew = this.onAddNew.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onLinkTypeChange = this.onLinkTypeChange.bind(this);
        this.onLinkIdChange = this.onLinkIdChange.bind(this);
        this.onGroupByChange = this.onGroupByChange.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onStartDateBlur = this.onStartDateBlur.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onEndDateBlur = this.onEndDateBlur.bind(this);
        this.onHeaderChange = this.onHeaderChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onStickyChange = this.onStickyChange.bind(this);
        this.onShowNewIconChange = this.onShowNewIconChange.bind(this);
        this.onSendEmailChange = this.onSendEmailChange.bind(this);
        this.onFileNameChange = this.onFileNameChange.bind(this)
        this.onNavigateUrlChange = this.onNavigateUrlChange.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();

        this.setState({
            startDateValue: this.getFormattedDate("startdate-datepicker"),
            endDateValue: this.getFormattedDate("enddate-datepicker")
        });
    }

    setEditValues(announcement) {
        self = this;
        
        let startDateIso = (new Date(announcement.formattedStartDate)).toISOString();
        let endDateIso = (new Date(announcement.formattedEndDate)).toISOString();
        self.setState({
            linkTypeValue: announcement.linkType,
            linkIdValue: announcement.linkId,
            groupByValue: announcement.groupBy,
            startDate: startDateIso,
            startDateValue: announcement.formattedStartDate,
            endDate: endDateIso,
            endDateValue: announcement.formattedEndDate,
            headerValue: announcement.header,
            descriptionValue: announcement.description,
            fileNameValue: announcement.fileName,
            navigateUrlValue: announcement.url
        });

        if (announcement.sticky) {
            document.getElementById('stickyyes').setAttribute('checked', 'true');
            this.setState({
                stickyValue: 'YES'
            })
        }
        else {
            document.getElementById('stickyno').setAttribute('checked', 'true');
            this.setState({
                stickyValue: 'NO'
            })
        }

        if (announcement.newIcon) {
            document.getElementById('showNewIconyes').setAttribute('checked', 'true');
            this.setState({
                showNewIconValue: 'YES'
            })
        }
        else {
            document.getElementById('showNewIconno').setAttribute('checked', 'true');
            this.setState({
                showNewIconValue: 'NO'
            })
        }

        if (announcement.sendMail) {
            document.getElementById('sendEmailyes').setAttribute('checked', 'true');
            this.setState({
                sendEmailValue: 'YES'
            })
        }
        else {
            document.getElementById('sendEmailno').setAttribute('checked', 'true');
            this.setState({
                sendEmailValue: 'NO'
            })
        }
    }

    setAddValues(data) {
        let linkTypeValue = '';

        if (data.linkTypes.length > 0) {
            linkTypeValue = data.linkTypes[0].linkTypeID
        }

        let endDateIso = (new Date(data.nowPlusOneMonth)).toISOString();
        this.setState({
            linkTypeValue: linkTypeValue,
            stickyValue: 'NO',
            showNewIconValue: 'NO',
            sendEmailValue: 'NO',
            groupByValue: 'People',
            fileNameValue: 'http://',
            navigateUrlValue: 'http://',
            endDate: endDateIso,
            endDateValue: data.formattedNowPlusOneMonth
        });

        document.getElementById('stickyno').setAttribute('checked', 'true');
        document.getElementById('showNewIconno').setAttribute('checked', 'true');
        document.getElementById('sendEmailno').setAttribute('checked', 'true');
    }

    loadViewModel() {
        let self = this;
        let path = this.props.location.pathname.split('/');
        let announcementId = '';
        let deleteButton = true;
        
        if (!isNaN(parseInt(path[path.length - 1]))) {
            if (path[path.length - 1] != '0') {
                announcementId = path[path.length - 1];
                deleteButton = false;
            }
        }

        self.setState({
            announcementIdValue: announcementId,
            deleteDisabled: deleteButton,
            errors: []
        })

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(`add-announcement/${announcementId}`)
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    linkTypeLabel: res.data.linkTypeLabel,
                    linkIdLabel: res.data.linkIdLabel,
                    groupByLabel: res.data.groupByLabel,
                    startDateLabel: res.data.startDateLabel,
                    endDateLabel: res.data.endDateLabel,
                    headerLabel: res.data.headerLabel,
                    descriptionLabel: res.data.descriptionLabel,
                    stickyLabel: res.data.stickyLabel,
                    showNewIconLabel: res.data.showNewIconLabel,
                    sendEmailLabel: res.data.sendEmailLabel,
                    fileNameLabel: res.data.fileNameLabel,
                    navigateUrlLabel: res.data.navigateUrlLabel,
                    saveLabel: res.data.saveLabel,
                    backLabel: res.data.backLabel,
                    addNewLabel: res.data.addNewLabel,
                    deleteLabel: res.data.deleteLabel,
                    showDetailLabel: res.data.showDetailLabel,
                    requiredLabel: res.data.requiredLabel,
                    confirmDeleteLabel: res.data.confirmDeleteLabel,
                    linkTypes: res.data.linkTypes,
                    yesNoList: res.data.yesNoList
                });

                if (res.data.announcement.announcementId !== undefined) {
                    if (res.data.announcement.announcementId > 0) {
                        self.setEditValues(res.data.announcement);
                    }
                    else {
                        self.setAddValues(res.data);
                    }
                }
                else {
                    self.setAddValues(res.data);
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    validate() {
        let msg = [];

        if (this.state.linkIdValue.trim() == '') {
            msg.push(this.state.linkIdLabel + ' ' + this.state.requiredLabel);
        }

        var startDate = this.getFormattedDate("startdate-datepicker");
        if (startDate.length == 0) {
            msg.push(this.state.startDateLabel + ' ' + this.state.requiredLabel);
            this.setState({
                startDate: null
            });
        }

        var endDate = this.getFormattedDate("enddate-datepicker");
        if (endDate.length == 0) {
            msg.push(this.state.endDateLabel + ' ' + this.state.requiredLabel);
            this.setState({
                endDate: null
            });
        }

        if (startDate.length > 0 && endDate.length > 0) {
            if ((new Date(startDate)) > new Date(endDate)) {
                msg.push("Invalid Date Range");
            }
        }

        if (this.state.headerValue.trim() == '') {
            msg.push(this.state.headerLabel + ' ' + this.state.requiredLabel);
        }

        if (this.state.descriptionValue.trim() == '') {
            msg.push(this.state.descriptionLabel + ' ' + this.state.requiredLabel);
        }

        return msg;
    }

    onSave() {
        var messages = this.validate();
        this.setState({
            errors: messages,
            alertStyle: 'danger'
        });

        if (messages.length == 0) {
            this.save();
        }
    }

    save() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        self.setState({
            errors: []
        });

        var announcementParam = {
            AnnouncementId: self.state.announcementIdValue,
            LinkType: self.state.linkTypeValue,
            LinkId: self.state.linkIdValue.trim(),
            GroupBy: self.state.groupByValue,
            StartDate: self.state.startDateValue.trim(),
            EndDate: self.state.endDateValue.trim(),
            Header: self.state.headerValue.trim(),
            Description: self.state.descriptionValue.trim(),
            Sticky: self.state.stickyValue == 'YES',
            NewIcon: self.state.showNewIconValue == 'YES',
            SendMail: self.state.sendEmailValue == 'YES',
            FileName: self.state.fileNameValue.trim(),
            Url: self.state.navigateUrlValue.trim()
        };

        if (self.state.announcementIdValue == '') {
            ajax.api().put(`add-announcement`, announcementParam)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        })
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            announcementIdValue: res.data.announcementId,
                            errors: msg,
                            deleteDisabled: false,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
        else {
            ajax.api().post('edit-announcement', announcementParam)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        })
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/manage-announcement';
    }

    onAddNew() {
        let self = this;
        window.location = context.root() + '/app/add-announcement/0';
    }

    onDelete() {
        self = this;

        self.setState({
            errors: []
        });

        if (confirm(self.state.confirmDeleteLabel) == true) {
            context.message({
                show: true, 
                type: "loading", 
                message:"Loading. Please wait..."
            });

            ajax.api().post(`delete-announcement/${this.state.announcementIdValue}`)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        })
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            announcementIdValue: '',
                            deleteDisabled: true,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    onLinkTypeChange (event) {
        this.setState({
            linkTypeValue: this.inputLinkType.value
        });
    }

    onLinkIdChange(event) {
        let value = event.target.value;

        this.setState({
            linkIdValue: value
        });
    }

    onGroupByChange() {
        this.setState({
            groupByValue: this.inputGroupBy.value
        });
    }

    onStartDateChange(value, formattedValue) {
        this.setState({
            startDate: value,
            startDateValue: formattedValue
        });
    }

    onStartDateBlur() {
        if (this.getFormattedDate('startdate-datepicker') == '') {
            this.setState({
                startDate: null,
                startDateValue: ''
            });
        }
    }

    onEndDateChange(value, formattedValue) {
        this.setState({
            endDate: value,
            endDateValue: formattedValue
        });
    }

    onEndDateBlur() {
        if (this.getFormattedDate('enddate-datepicker') == '') {
            this.setState({
                endDate: null,
                endDateValue: ''
            });
        }
    }

    onHeaderChange(event) {
        let value = event.target.value;

        this.setState({
            headerValue: value
        });
    }

    onDescriptionChange(event) {
        let value = event.target.value; 

        this.setState({
            descriptionValue: value
        });
    }
    
    onStickyChange(event) {
        let value = event.target.value; 

        this.setState({
            stickyValue: value
        });
    }

    onShowNewIconChange(event) {
        let value = event.target.value; 

        this.setState({
            showNewIconValue: value
        });
    }
        
    onSendEmailChange(event) {
        let value = event.target.value; 

        this.setState({
            sendEmailValue: value
        });
    }
        
    onFileNameChange(event) {
        let value = event.target.value; 

        this.setState({
            fileNameValue: value
        });
    }
        
    onNavigateUrlChange(event) {
        let value = event.target.value; 

        this.setState({
            navigateUrlValue: value
        });
    }

    getLinkTypeListToRender() {
        var linkTypesToRender = [];
        
        this.state.linkTypes.map(function (item, i) {
            linkTypesToRender.push(<option key={item.linkTypeID} value={item.linkTypeID}>{item.linkType}</option>)
        }, this);

        return linkTypesToRender;
    }

    getYesNoListToRender(groupName, changeEvent) {
        var yesNoListToRender = [];
        
        this.state.yesNoList.map(function (item, i) {
            var id = groupName + item.code.toLowerCase();
            yesNoListToRender.push(
                <Radio id={id} name={groupName} 
                    value={item.code}
                    onChange={changeEvent} inline>{item.codeName}</Radio>)
        }, this);

        return yesNoListToRender;
    }

    getFormattedDate(id) {
        return document.getElementById(id).getAttribute("data-formattedvalue").trim(); // accessed value from dom because handle change isn't fired when removed
    }

    render() {
        var requiredStyle = {
            "color": "red"
        };

        var rowPaddingTopStyle = {
            "padding-top": "10px"
        };

        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.linkTypeLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl
                                componentClass="select"
                                placeholder="select"
                                value={this.state.linkTypeValue}
                                onChange={this.onLinkTypeChange}
                                inputRef={el => this.inputLinkType = el}>
                                {this.getLinkTypeListToRender()}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.linkIdLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.linkIdValue}
                                onChange={this.onLinkIdChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.groupByLabel} </ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl
                                componentClass="select"
                                placeholder="select"
                                onChange={this.onGroupByChange}
                                inputRef={el => this.inputGroupBy = el}>
                                <option value="People" selected="true">Associate</option>
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.startDateLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <DatePicker id="startdate-datepicker" placeholder="MM/DD/YYYY" value={this.state.startDate}
                                onChange={this.onStartDateChange}
                                onBlur={this.onStartDateBlur} />
                        </div>
                    </div>
                    <div className="row" style={rowPaddingTopStyle}>
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.endDateLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <DatePicker id="enddate-datepicker" placeholder="MM/DD/YYYY" value={this.state.endDate}
                                onChange={this.onEndDateChange}
                                onBlur={this.onEndDateBlur} />
                        </div>
                    </div>
                    <div className="row" style={rowPaddingTopStyle}>
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.headerLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.headerValue}
                                onChange={this.onHeaderChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.descriptionLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl componentClass="textarea" rows="10"
                                value={this.state.descriptionValue}
                                onChange={this.onDescriptionChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.stickyLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            {this.getYesNoListToRender("sticky", this.onStickyChange)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.showNewIconLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            {this.getYesNoListToRender("showNewIcon", this.onShowNewIconChange)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.sendEmailLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            {this.getYesNoListToRender("sendEmail", this.onSendEmailChange)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.fileNameLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" disabled="true"
                                value={this.state.fileNameValue}
                                onChange={this.onFileNameChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.navigateUrlLabel}</ControlLabel>
                            <br />
                            <ControlLabel>Please include "http://</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" disabled="true"
                                value={this.state.navigateUrlValue}
                                onChange={this.onNavigateUrlChange}></FormControl>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-3 col-lg-3"></div>
                        <div className="col-md-3 col-lg-9">
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onSave} className="btn-info ap-fullsize" >{this.state.saveLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onBack} className="btn-info ap-fullsize" >{this.state.backLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onAddNew} className="btn-info ap-fullsize" >{this.state.addNewLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onDelete} className="btn-info ap-fullsize" disabled={this.state.deleteDisabled}>{this.state.deleteLabel}</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={rowPaddingTopStyle}>
                    <div className="col-md-12 col-lg-12">
                        <div className="col-md-12 col-lg-12">
                            <Alert bsStyle={this.state.alertStyle} className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                <ul>
                                    {this.state.errors.map(m =>
                                        <li key={m}>{m}</li>)}
                                </ul>
                            </Alert>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}